export enum CampaignState {
  Active,
  Passed,
}
